import {useMemo} from 'react'
import {useLocation} from 'react-router-dom'

import type {ModalId} from '../types'

const MODAL_QUERY_KEY = 'modal'

export function useModalState(modalId: ModalId) {
  const {search} = useLocation()

  const searchParams = useMemo(() => new URLSearchParams(search), [search])

  return {
    isOpened: searchParams.get(MODAL_QUERY_KEY) === modalId,
  }
}
